import { UpdateExperimentSettingsFormFieldNames } from './updateExperimentSettings';

export const AUDIENCE_BREAKDOWN_FORM_FIELDS = [
  UpdateExperimentSettingsFormFieldNames.HAS_HOLDOUT_GROUP,
  UpdateExperimentSettingsFormFieldNames.HOLDOUT_GROUP_SIZE,
  UpdateExperimentSettingsFormFieldNames.TEST_STRATEGY,
  UpdateExperimentSettingsFormFieldNames.HOLDOUT_TEST_SIZE_PERCENTAGE,
];

// label for bottom block don't fit under 5%
// label for total value in bottom block comes off the component at 6%
export const MIN_SECTION_WIDTH_FOR_LABELS = 5;
export const MIN_SECTION_WIDTH_FOR_TOTALS = 6;
